<template>
  <div class="file-download" @click="downloadFile">
    <div class="icon-wrapper">
      <file-icon :file="file"></file-icon>
    </div>
    <div class="file-name">{{ file.name }}</div>
  </div>
</template>

<script>
import FileIcon from "../file/icon/component.vue";

export default {
  name: "file-download",
  components: {FileIcon},
  props: {
    file: {
      type: Object,
      required: true,
    },
  },
  methods: {
    downloadFile() {
      window.open(this.file.downloadLink, "_blank");
    },
  },
};
</script>

<style scoped lang="scss">
.file-download {
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  width: 150px;
  word-wrap: break-word;
  text-align: center;

  .icon-wrapper {
    font-size: 2rem;

    svg {
      color: $primary;
    }
  }

  .file-name {
    margin-top: 5px;
  }

  &:hover {
    .icon-wrapper {
      svg {
        color: $secondary;
      }
    }

  }
}
</style>